import {Component, EventEmitter, Inject, Input, OnInit, Output,} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef,} from '@angular/material/dialog';
import {SwissFieldControlService} from 'src/app/services/swissfieldcontrol.service';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {ObjektModels} from 'src/app/models/objekt-models';
import {v4 as uuidv4} from 'uuid';
import {catchError, debounceTime} from 'rxjs/operators';
import {AdresseDataService} from 'src/app/services/adresse-data.service';
import {AdresseModels} from 'src/app/models/adresse-models';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {BenutzerModels} from 'src/app/models/benutzer-models';
import {UserAuthenticationService} from '../../services/user-authentication.service';
import {BehaviorSubject, firstValueFrom, of} from 'rxjs';

@Component({
    selector: 'app-objekt-dialog', templateUrl: './objekt-dialog.component.html', styleUrls: ['./objekt-dialog.component.scss'], providers: [SwissFieldControlService],
})
export class ObjektDialogComponent implements OnInit {
    @Input() objektDialogInput!: ObjektModels.ObjektDialogInput;
    @Input() isDialog = true;

    @Output() close = new EventEmitter<any>();
    @Output() submit = new EventEmitter<any>();

    formGrp!: UntypedFormGroup;
    currObjekt: ObjektModels.ObjektElement = ObjektModels.EmptyObjektElement();
    parentObjekt?: ObjektModels.ObjektElement;
    parentObjectAdresses?: ObjektModels.ObjektAdresseZuord[];
    objektDialogResult: ObjektModels.ObjektDialogResult;
    istKeinAuftrag = true;
    onRootLevel = false;
    allowChangeRootLevel = true;
    public innerWidth: any;
    // Berechtigungen
    public rechtObjektLiegenschaftErstellen = false;
    public rechtObjektOrdnerErstellen = false;
    public rechtObjektLieferantErstellen = false;
    public rechtObjektMitarbeiterErstellen = false;
    public rechtObjektKundeErstellen = false;
    public title = 'MAIN_APP_DIALOG.OBJECT_DIALOG.newObject';
    showFirstHalf = true;
    swissFieldByPage: any[] = [];
    pageCounter = 0;
    objectTypeChange$: BehaviorSubject<string>;
    blockSaving: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private adresse?: AdresseModels.DetailAdresseElement;

    constructor(private svcObjektData: ObjektDataService,
                private svcAdressen: AdresseDataService,
                private sfcs: SwissFieldControlService,
                private userAuthService: UserAuthenticationService,
                public dialog: MatDialog,
                private fb: UntypedFormBuilder,
                private svcMessageBox: MessageBoxService,
                public dialogRef: MatDialogRef<ObjektDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.objektDialogInput = data;
        this.objektDialogResult = {
            objektElement: ObjektModels.EmptyObjektElement(), swissFields: []
        };
        this.objectTypeChange$ = new BehaviorSubject<string>(this.objektDialogInput.objectType || '1');
        this.formGrp = this.fb.group({});
        this.initUserRights();
        this.svcObjektData.registerAddAdressInObjectDialogFunc(this.onAdressChange.bind(this));
    }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        this.loadDialogFormFields().then(() => {
            this.currObjekt = ObjektModels.EmptyObjektElement();
            if (this.objektDialogInput.objectType) {
                this.currObjekt.objectType = this.objektDialogInput.objectType;
                this.objectTypeChange$.next(this.currObjekt.objectType);
            }
            if (this.objektDialogInput && this.objektDialogInput.parentObjectID) {
                // Übergeordnetes Objekt ermitteln
                this.svcObjektData
                    .getObjektByID(this.objektDialogInput.parentObjectID)
                    .subscribe({
                        next: (res: ObjektModels.ObjektElement | undefined) => {
                            this.parentObjekt = res;
                            this.svcObjektData
                                .getObjektAdressenZuordnungen(this.objektDialogInput.parentObjectID)
                                .subscribe({
                                    next: (res: ObjektModels.ObjektAdresseZuord[] | undefined) => {
                                        this.parentObjectAdresses = res;
                                        if (this.parentObjectAdresses) {
                                            this.setAddressesFromParent();
                                        }
                                    }, error: (err: any) => console.error('Fehler bei der ObjektAdressZuordnungs-Ermittlung.', err)
                                });
                        },
                    });
            } else {
                this.onRootLevel = true;
                this.allowChangeRootLevel = false;
            }
        });
    }

    nextPart() {
        this.pageCounter++;
    }

    prevPart() {
        this.pageCounter--;
    }

    onAdressChange(oaz: ObjektModels.ObjektAdresseZuord) {
        // console.log("objekt-dialog: onAdressChange", oaz);
        this.objektDialogResult.objektAdresseZuord = oaz;
        this.svcAdressen.getAddressByID(this.objektDialogResult.objektAdresseZuord.adressID).then(res => {
            this.adresse = res;

            // Wenn das Feld für die Adresse vorhanden ist => abfüllen
            if (this.formGrp.controls.ObjAdr) {
                this.formGrp.controls.ObjAdr.setValue(this.adresse!.street1);
            }

            if (this.formGrp.controls.ObjPlz) {
                this.formGrp.controls.ObjPlz.setValue(this.adresse!.zip);
            }

            if (this.formGrp.controls.ObjOrt) {
                this.formGrp.controls.ObjOrt.setValue(this.adresse!.city);
            }

            if (this.formGrp.controls.ObjBez) {
                this.presetObjDesc();
            }

            if (this.formGrp.controls.ObjName) {
                this.presetObjNote4();
            }
        }).catch(() => console.error('Die Adresse konnte nicht ermittelt werden'));
    }

    async onChangeValue(key: string, data: any) {
        if (key === 'ObjTyp') {
            this.onRootLevel = data === '1'; // 1 = Liegenschaft
            if (!this.formGrp.controls.hasOwnProperty('ObjectNumberRange')) {
                await this.regenAndSetObjectNr(data);
            } else {
                this.objectTypeChange$.next(data);
            }
        }
        if (key === 'ObjectNumberRange') {
            await this.regenAndSetObjectNr(null);
        }
        this.blockSaving.next(this.formGrp.invalid);
    }

    onRootLevelChange(event: any) {
        this.onRootLevel = event.source.checked;
    }

    onSubmit(): void {
        if (this.formGrp.status === 'VALID') {
            if (this.objektDialogResult.swissFields) {
                for (const swissField of this.objektDialogResult.swissFields) {
                    if (!swissField.options.key) {
                        return;
                    }
                    const value = this.formGrp.get(swissField.options.key)?.value;
                    if (value && swissField.options.dataBinding) {
                        (this.currObjekt as any)[swissField.options.dataBinding as keyof ObjektModels.ObjektElement] = value;
                    }
                }
            }
            if (this.currObjekt && this.currObjekt.objectID == '') {
                this.svcObjektData.getObjectNumberIsFree(this.currObjekt.objectNumber.toString()).subscribe({
                    next: (x) => {
                        if (x) {
                            this.currObjekt.objectID = uuidv4();

                            if (!this.onRootLevel && this.objektDialogInput.parentObjectID) {
                                this.currObjekt.parentObject = this.objektDialogInput.parentObjectID;
                            }

                            this.currObjekt.objectNumber = this.currObjekt.objectNumber.toString(); // Objektnummer könnte nummerisch im Objekt sein
                            this.objektDialogResult.objektElement = this.currObjekt;
                            this.dialogRef.close(this.objektDialogResult);
                        } else {
                            this.svcMessageBox.showErrorOK('MAIN_APP_DIALOG.ERROR_DIALOG.OBJECT_NR_EXISTS.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.OBJECT_NR_EXISTS.title');
                        }
                    }, error: () => {
                        this.svcMessageBox.showError('Die Objektnummer konnte nicht überprüft werden.', '!! FEHLER !!');
                    }
                });
            }
        }
    }

    toLowerFirstLetter(value: string) {
        return value.charAt(0).toLowerCase() + value.slice(1);
    }

    presetObjDesc() {
        // Die konfigurierten Felder müssen 1:1 mit der Datenbank übereinstimmen (Gross-/Kleinschreibung ist wichtig!!)
        let presetConfig = this.svcObjektData.getSwissAppConfig()?.presetObjectDescription;
        if (presetConfig) {
            const fieldArray = presetConfig.split(',');
            if (fieldArray.length > 0) {
                fieldArray.forEach((field) => {
                    const feldMitPlatzhalter = field.trim();
                    let feldOhnePlatzhalter = feldMitPlatzhalter.substring(1); // $-Zeichen entfernen
                    // erstes Zeichen muss klein sein
                    feldOhnePlatzhalter = this.toLowerFirstLetter(feldOhnePlatzhalter);
                    const wert = this.adresse![feldOhnePlatzhalter as keyof AdresseModels.DetailAdresseElement];
                    if (wert) {
                        presetConfig = presetConfig?.replace(feldMitPlatzhalter, wert!.toString());
                    } else {
                        presetConfig = presetConfig?.replace(feldMitPlatzhalter, '');
                    }
                });
                this.formGrp.controls.ObjBez.setValue(presetConfig);
            }
        }
    }

    presetObjNote4() {
        // Die konfigurierten Felder müssen 1:1 mit der Datenbank übereinstimmen (Gross-/Kleinschreibung ist wichtig!!)
        let presetConfig = this.svcObjektData.getSwissAppConfig()?.presetObjectNote4;
        if (presetConfig) {
            const fieldArray = presetConfig.split(',');
            if (fieldArray.length > 0) {
                fieldArray.forEach((field) => {
                    const feldMitPlatzhalter = field.trim();
                    let feldOhnePlatzhalter = feldMitPlatzhalter.substring(1); // $-Zeichen entfernen
                    // erstes Zeichen muss klein sein
                    feldOhnePlatzhalter = this.toLowerFirstLetter(feldOhnePlatzhalter);
                    const wert = this.adresse![feldOhnePlatzhalter as keyof AdresseModels.DetailAdresseElement];
                    if (wert) {
                        presetConfig = presetConfig?.replace(feldMitPlatzhalter, wert!.toString());
                    } else {
                        presetConfig = presetConfig?.replace(feldMitPlatzhalter, '');
                    }
                });
                this.formGrp.controls.ObjName.setValue(presetConfig);
            }
        }
    }

    onCancel() {
        this.dialogRef.close('canceled');
    }

    private async regenerateObjectNumber(objectType: string, parentID: string | undefined = undefined, objectNumberRange: string | undefined = undefined): Promise<string> {
        const params = {
            parentObjectID: parentID,
            objectNumberRangeID: objectNumberRange
        };

        const objectNumber = await firstValueFrom(this.svcObjektData.getObjectNumber(objectType, params).pipe(
            catchError((err) => {
                if (err.error.status === 409 && err.error.type === 'ObjectNumberRangeExhaustedException') {
                    this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.OBJECT_NR_RANGE_EXHAUSTED.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.OBJECT_NR_RANGE_EXHAUSTED.title');
                }
                if (err.error.status === 500) {
                    this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.OBJECT_NR_RANGE_EXHAUSTED.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.OBJECT_NR_RANGE_EXHAUSTED.title');
                }
                return of('');
            })
        ));
        if (objectNumber) {
            return this.formatObjectNumber(objectNumber);
        }
        throw new Error('Objektnummer konnte nicht generiert werden.');
    }

    private async regenAndSetObjectNr(objectTypeOverride: string | null): Promise<void> {
        this.formGrp.controls.ObjectNr.setValue(undefined);
        this.blockSaving.next(true);
        this.formGrp.updateValueAndValidity();
        if (!this.formGrp.controls.hasOwnProperty('ObjectNr')) {
            throw new Error('ObjectNr-Feld nicht gefunden.');
        }
        let objectType = '0';
        if (objectTypeOverride === null) {
            objectType = this.objectTypeChange$.getValue();
        } else {
            objectType = objectTypeOverride;
        }

        if (objectType === '0') {
            return;
        }
        const parentObjectID = this.objektDialogInput.parentObjectID;
        const objectNumberRange = this.formGrp.controls.ObjectNumberRange.value;
        const formatted = await this.regenerateObjectNumber(objectType, parentObjectID, objectNumberRange);
        this.formGrp.controls.ObjectNr.setValue(formatted);
        this.blockSaving.next(false);
        this.formGrp.updateValueAndValidity();
    }

    private async getObjectNumberRange(objectType: string): Promise<string | undefined> {
        let objectNumberRangeID: string | undefined = undefined;
        if (this.formGrp.contains('ObjectNrRange') && objectType !== '0') {
            const objectNumberRanges = (await firstValueFrom(this.svcObjektData.getObjectRangeOptions(objectType)));
            if (objectNumberRanges.length > 0) {
                objectNumberRangeID = objectNumberRanges[0].id;
            }
        }
        return objectNumberRangeID;
    }

    private async loadDialogFormFields(): Promise<boolean> {
        if (this.objektDialogInput.objectType === '2' || this.objektDialogInput.objectType === '4') {
            this.istKeinAuftrag = false;
        }

        if (this.objektDialogInput.objectType === '2') {
            this.title = 'MAIN_APP_DIALOG.OBJECT_DIALOG.newOrder';
        } else if (this.objektDialogInput.objectType === '4') {
            this.title = 'MAIN_APP_DIALOG.OBJECT_DIALOG.newProdOrder';
        }

        let swissFields;
        if (this.objektDialogInput.objectType) {
            swissFields = await firstValueFrom(this.svcObjektData.getFormFieldsByObjType(3, this.objektDialogInput.objectType, true));
        } else {
            swissFields = await firstValueFrom(this.svcObjektData.getFormFields(3));
        }

        try {
            if (swissFields) {
                if (this.objektDialogInput.objectType) {
                    await this.svcObjektData.setOfflineFormFields(3, this.objektDialogInput.objectType, swissFields);
                }

                swissFields.forEach((field) => {
                    field.isNewEntity = true;

                    if (!this.objektDialogInput.objectType && field.options.dataBinding === 'objectType') {
                        const objTypenMitBerechtigung: {
                            key: string;
                            value: string;
                        }[] = [];

                        field.options.optionsNeu.forEach((elem) => {
                            if (elem.key === '1' && this.rechtObjektLiegenschaftErstellen) {
                                objTypenMitBerechtigung.push(elem);
                            } else if (elem.key === '3' && this.rechtObjektOrdnerErstellen) {
                                objTypenMitBerechtigung.push(elem);
                            } else if (elem.key === '5' && this.rechtObjektLieferantErstellen) {
                                objTypenMitBerechtigung.push(elem);
                            } else if (elem.key === '6' && this.rechtObjektMitarbeiterErstellen) {
                                objTypenMitBerechtigung.push(elem);
                            } else if (elem.key === '7' && this.rechtObjektKundeErstellen) {
                                objTypenMitBerechtigung.push(elem);
                            }
                        });
                        field.options.optionsNeu = objTypenMitBerechtigung;
                        this.objektDialogInput.objectType = field.options.optionsNeu[0].key;
                    }

                });

                this.objektDialogResult.swissFields = swissFields.sort((a, b) => a.options.order! - b.options.order!);
                this.formGrp = await this.sfcs.toFormGroup(this.objektDialogResult.swissFields);

                if (this.objektDialogInput.objectType) {
                    this.currObjekt.objectType = this.objektDialogInput.objectType;
                    if (this.formGrp.controls.hasOwnProperty('ObjectNr')) {
                        console.log(this.currObjekt.objectType);
                        const objectNumberRangeID = await this.getObjectNumberRange(this.currObjekt.objectType);

                        let parentObjectID: string | undefined = undefined;
                        if (this.currObjekt.objectType === '4') {
                            parentObjectID = this.objektDialogInput.parentObjectID;
                        }

                        try {
                            const objectNumber = await firstValueFrom(this.svcObjektData.getObjectNumber(this.currObjekt.objectType, {parentObjectID, objectNumberRangeID}));
                            this.formGrp.controls.ObjectNr.setValue(this.formatObjectNumber(objectNumber));
                        } catch {
                            this.svcMessageBox.showErrorByLanguageKey('', '');
                        }
                    }

                }

                this.addEventsToControls();

                this.swissFieldByPage = [];
                this.swissFieldByPage.push(this.objektDialogResult.swissFields.slice(0, 4));
                this.swissFieldByPage.push(this.objektDialogResult.swissFields.slice(5, 9));
                this.swissFieldByPage.push(this.objektDialogResult.swissFields.slice(10, 15));
                return true;
            }
        } catch (err) {
            this.svcMessageBox.showError('Fehler beim Laden der Objekt-Felder.', '!! FEHLER !!');
        }
        return false;
    }

    private initUserRights() {
        this.rechtObjektLiegenschaftErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteLiegenschaftErstellen);
        this.rechtObjektOrdnerErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteOrdnerErstellen);
        this.rechtObjektLieferantErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteLieferantErstellen);
        this.rechtObjektMitarbeiterErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteMitarbeiterErstellen);
        this.rechtObjektKundeErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteKundeErstellen);
    }

    private addEventsToControls() {
        Object.keys(this.formGrp.controls).forEach((key) => {
            this.formGrp
                .get(key)
                ?.valueChanges.pipe(debounceTime(300))
                .subscribe({
                    next: (data) => {
                        this.onChangeValue(key, data); // Wenn der Objekt-Typ ändert, muss darauf reagiert werden
                    },
                });
        });
    }

    private setAddressesFromParent() {
        if (this.parentObjectAdresses) {
            this.parentObjectAdresses.forEach((oaz) => {
                oaz.id = '00000000-0000-0000-0000-000000000000';

                if (oaz.addressType === 1) {
                    // Kundenadresse
                    if (this.formGrp.contains('AdrBoxChoiceKunde')) {
                        this.svcObjektData.getAdressViewContent(oaz).subscribe({
                            next: (res: any) => {
                                if (res) {
                                    const index = this.objektDialogResult.swissFields.findIndex((x) => x.options.key == 'AdrBoxChoiceKunde');
                                    if (index >= 0) {
                                        this.objektDialogResult.swissFields[index].objektAdressZuordnungen = [];
                                        this.objektDialogResult.swissFields[index].objektAdressZuordnungen!.push(oaz);
                                        this.formGrp.controls.AdrBoxChoiceKunde.patchValue(res);
                                    }
                                }
                            }, error: (err: any) => console.error('Fehler beim Ermitteln der AnzeigeAdresse', err),
                        });
                    }
                } else if (oaz.addressType === 2) {
                    // Rechnungsadresse
                    if (this.formGrp.contains('AdrBoxChoiceRech')) {
                        this.svcObjektData.getAdressViewContent(oaz).subscribe({
                            next: (res: any) => {
                                if (res) {
                                    const index = this.objektDialogResult.swissFields.findIndex((x) => x.options.key == 'AdrBoxChoiceRech');
                                    if (index >= 0) {
                                        this.objektDialogResult.swissFields[index].objektAdressZuordnungen = [];
                                        this.objektDialogResult.swissFields[index].objektAdressZuordnungen!.push(oaz);
                                        this.formGrp.controls.AdrBoxChoiceRech.patchValue(res);
                                    }
                                }
                            }, error: (err: any) => console.error('Fehler beim Ermitteln der AnzeigeAdresse', err),
                        });
                    }
                } else if (oaz.addressType === 3) {
                    // Architektadresse
                    if (this.formGrp.contains('AdrBoxChoiceArch')) {
                        this.svcObjektData.getAdressViewContent(oaz).subscribe({
                            next: (res: any) => {
                                if (res) {
                                    const index = this.objektDialogResult.swissFields.findIndex((x) => x.options.key == 'AdrBoxChoiceArch');
                                    if (index >= 0) {
                                        this.objektDialogResult.swissFields[index].objektAdressZuordnungen = [];
                                        this.objektDialogResult.swissFields[index].objektAdressZuordnungen!.push(oaz);
                                        this.formGrp.controls.AdrBoxChoiceArch.patchValue(res);
                                    }
                                }
                            }, error: (err: any) => console.error('Fehler beim Ermitteln der AnzeigeAdresse', err),
                        });
                    }
                } else if (oaz.addressType === 4) {
                    // Lieferantadrese
                    if (this.formGrp.contains('AdrBoxChoiceLief')) {
                        this.svcObjektData.getAdressViewContent(oaz).subscribe({
                            next: (res: any) => {
                                if (res) {
                                    const index = this.objektDialogResult.swissFields.findIndex((x) => x.options.key == 'AdrBoxChoiceLief');
                                    if (index >= 0) {
                                        this.objektDialogResult.swissFields[index].objektAdressZuordnungen = [];
                                        this.objektDialogResult.swissFields[index].objektAdressZuordnungen!.push(oaz);
                                        this.formGrp.controls.AdrBoxChoiceLief.patchValue(res);
                                    }
                                }
                            }, error: (err: any) => console.error('Fehler beim Ermitteln der AnzeigeAdresse', err),
                        });
                    }
                }
            });
        }
    }

    private formatObjectNumber(objectNumber: string): string {
        // Die Objektnummer 100310.10 wird vom Webservice richtig zurück geliefert,
        // Es wird im Frontend aber die abschliessende 0 entfernt => 100310.1
        // for some reason this is sometimes a number
        objectNumber = objectNumber.toString();
        if (objectNumber.lastIndexOf('.') > 0 && objectNumber.lastIndexOf('.') + 2 == objectNumber.length) {
            objectNumber = objectNumber += '0';
        }
        return objectNumber;
    }
}
